import { render, staticRenderFns } from "./AuthorizationOverview.vue?vue&type=template&id=4698993e&"
import script from "./AuthorizationOverview.vue?vue&type=script&lang=js&"
export * from "./AuthorizationOverview.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationOverview.vue?vue&type=style&index=0&id=4698993e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports